import {
  DEFAULT_DIR,
  DEFAULT_LANG,
  DEFAULT_THEME_MODE,
  NAV_TYPE_SIDE,
  SIDE_NAV_LIGHT,
} from "../constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "CAPMAS";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const EXTERNAL_TRADE_BASE_URL = env.API_EXTERNAL_TRADE_ENDPOINT_URL;
export const SEARCH_BASE_URL = env.SEARCH_API_ENDPOINT_URL;
export const API_POPULATION_BASE_URL = env.API_POPULATION_ENDPOINT_URL;
export const API_LIVE_POPULATION_BASE_URL = env.API_LIVE_POPULATION_ENDPOINT_URL;
export const APP_PREFIX_PATH = "";
export const AUTH_PREFIX_PATH = "/auth";
export const SOCIAL_MEDIA_APP_ID = {
  FACEBOOK: 825119169387896,
};
export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: DEFAULT_LANG,
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: DEFAULT_THEME_MODE,
  direction: DEFAULT_DIR,
};
